export default {
  featuredExperiences: '精选体验',
  searchAllExperiences: '搜索所有体验',
  searchAll: '搜索全部',
  groupSize: '团体规模',
  eventSize: '活动规模',
  upTo: '最多',
  whatWeDo: '我们将做什么',
  hostedBy: '主办方',
  whatsIncluded: '包含内容',
  avail: '可用性',
  whereWeAre: '地点',
  experienceCalendar: '体验日历',
  experienceCancelled: '体验已取消',
  experienceStartingPrice: '起价 {{price}}',
  experienceTotalPrice: '总计 {{price}}',
  at: '在',
  viewPrivateSessAvailability: '查看私人课程可用性',
  selectSession: '选择课程',
  sessionsCount: '{{count}}个时间 — 选择时间',
  noAvailability: '无可用时段',
  select: '选择',
  slotLeft: '剩余 {{remainSlots}} 个名额',
  slotsLeft: '剩余 {{remainSlots}} 个名额',
  spotsLeft: '剩 {{count}}',
  spotsLeftAriaLabel: '剩 {{count}} 个位置',
  bookExperience: '预订体验',
  book: '预订',
  learnMore: '了解更多',
  apply: '应用',
  maxPartySizes: '每组最多 {{maxGroupSize}} 个名额',
  maxPartySize: '每组最多 {{maxGroupSize}} 个名额',
  selectSessionValidation: '请选择课程',
  selectParticipantValidation: '请选择参与者',
  selectDateValidation: '请选择日期',
  reminders: '提醒',
  seeOtherDates: '查看其他日期',
  location: '位置',
  about: '关于',
  allExperiences: '所有体验',
  soldOut: '已售罄',
  reviews: '评价',
  reviewSingular: '评价',
  reviewPlural: '评价',
  dateOfExperience: '体验日期',
  readLess: '收起',
  readMore: '展开',
  seeMore: '查看更多',
  details: '详情',
  durationHour: '小时',
  durationHours: '小时',
  durationMinutes: '分钟',
  theFollowingVideoDoesNotContainAnyAudio: '以下视频不包含音频',
  by: '由',
  chooseATime: '为 {{title}} 选择时间',
  amenities: '设施',
  ticketSalesOpenIn: '距售票开始还有',
  ticketSalesOpen: '售票已开始',
  ticketSalesCloseIn: '距售票结束还有',
  ticketSalesClose: '售票已结束',
  ticketSalesClosed: '售票已结束',
  comingSoon: '即将推出',
  inPartnershipWith: '合作伙伴',
  notFoundExperienceTitle: '此体验已不可用',
  notFoundExperienceSubtitle: '可能已取消发布，或链接已失效。',
  deadLinkRecoverySubtitle: '探索可预订的其他体验',
  viewAllExperiences: '查看所有体验',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p>登录您的凯悦天地账户预订此体验，每 1 美元认可消费均可<strong>获享 5 点基本积分</strong></p>',
      basePoints:
        '<p>登录您的凯悦天地账户预订此体验，每 1 美元认可消费均可<strong>获享 10 点基本积分</strong></p>',
      additionalBonusPoints:
        '<p>使用凯悦天地信用卡进行预订，每 1 美元认可消费可<strong>额外获享 4 点奖励积分</strong></p>',
      additionalBonusPointsTier:
        '<p>根据您的会籍级别，还可<strong>获享高达 30% 的额外</strong>奖励积分</p>',
      payWithPoints: '<p>预订体验时，可<strong>使用积分支付</strong></p>',
    },
  },
};
